module.exports = __webpack_public_path__ + "Participant Notice 08_19_2024_1.pdf";